import React, { useState } from 'react'
import ModalBasic from '../../component/ModalBasic'
import BookingServices from '../../../services/axiosServices/apiServices/BookingServices';
import { useNavigate } from "react-router-dom";
import SwalServices from '../../../services/swalServices/SwalServices';
import ButtonLoader from '../../../components/common/buttonLoader/ButtonLoader';

const AcceptBookingCancellation = ({ modalOpen, setModalOpen, bookingCancellationDetails,getBookingCancellationDetailsById}) => {

    const bookingServices = new BookingServices();
    const swalServices = new SwalServices();
    const [amount, setAmount] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const Navigate = useNavigate()
    const handleChange = (e) => {
        let value = e.target.value;
        // value = isNaN(value) ? 0 : Number(value);
        value =value.replace(/-/g, "").replace(/(\..*)\./g, "$1")
        setAmount(value);
    }
    const handleClose = () => {
        setAmount(null)
        setModalOpen(false);
    }

    const handleSubmit = () => {
        if (amount != null) {
            setIsLoading(true);
            let req = {
                gMAPMemberId: 0,
                eventId: bookingCancellationDetails?.eventId,
                eventTimeSlotId: bookingCancellationDetails?.eventTimeSlotId,
                bookingId: bookingCancellationDetails?.bookingId,
                RefundAmount: Number(amount),
                IsRefund: bookingCancellationDetails?.paymentStatus == "Booked" ? 1 : 0,
                promoCode: bookingCancellationDetails?.promoCode ?? ""
            }
             bookingServices.generateCreditNoteForBooking(req).then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    const details = response?.responseItem?.responseContent;
                    setIsLoading(false);
                    swalServices.Success("Request Submit")
                    //getBookingCancellationDetailsById(bookingCancellationDetails?.cancellationId)
                    handleClose()
                    Navigate("/booking/BookingCancellation");
                } else {
                    setIsLoading(false);
                    swalServices.Error(response.message);
                    handleClose()
                }
            });
        }
    }



    return (
        <>
            <ModalBasic
                id="add-edit-modal"
                className="membership-add-edit-modal"
                modalOpen={modalOpen}
                setModalOpen={() => handleClose()}
                title="Cancellation Request Modal"
            >
                <div className="p-6">
                    <div className="grid grid-cols-12 gap-6">
                        <div className="col-span-12">
                            <label
                                htmlFor="amount"
                                className="block text-gray-700 font-medium mb-2"
                            >
                                Amount
                            </label>

                            <input
                                id="amount"
                                type="number"
                                name="amount"
                                value={amount ?? ""}
                                onChange={handleChange}
                                placeholder="Enter value"
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                            />

                            <div className="mt-4 flex justify-end">
                                {isLoading ? <ButtonLoader className="buttonload group relative rounded-md btn btn-red text-xl text-white focus:outline-none"/> : <button
                                    onClick={handleSubmit}
                                    // className="hover:bg-blue-700 active:bg-blue-800 text-white font-semibold px-6 py-2 rounded-md transition duration-200  btn-red"
                                    disabled={amount == null ? true : false}
                                    className={`px-6 py-2 rounded-md font-semibold transition duration-200 ${amount == undefined ? "bg-gray-300 text-gray-500 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white cursor-pointer btn-red"}`}
                                >
                                    Submit
                                </button>}
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBasic>
        </>
    )
}

export default AcceptBookingCancellation
